import { MouseEvent } from 'react';

// The row's own <Link> already navigates; a row click that started on it must not push twice
export const isFromLink = (event?: MouseEvent): boolean =>
  event?.target instanceof Element && Boolean(event.target.closest('a'));
